import { Button, Dialog, MenuItem, Stack, Typography } from '@mui/material';
import { ClearIcon } from '@mui/x-date-pickers';
import { useRedeemsModal } from '../hooks/redeems-modal.hook';
import FormProvider from 'src/components/hook-form/form-provider';
import { RHFSelect } from 'src/components/hook-form';

type RedeemsModalProps = {
  productHook: any;
};

export default function RedeemsModal({ productHook }: RedeemsModalProps) {
  const hook = useRedeemsModal({ productHook });
  return (
    <Dialog maxWidth="sm" fullWidth open={productHook.openRedeemModal}>
      <Stack
        spacing={4}
        sx={{
          p: 4,
        }}
      >
        <Stack
          direction="row"
          sx={{
            justifyContent: 'space-between',
            alignItems: 'flex-start',
          }}
        >
          <Typography fontWeight="bold">Associar Resgatável</Typography>
          <ClearIcon
            onClick={() => {
              productHook.onCloseRedeemModal();
              hook.reset();
            }}
            sx={{
              cursor: 'pointer',
            }}
          />
        </Stack>
        <FormProvider methods={hook.methods} onSubmit={hook.onSubmit}>
          <Stack spacing={2}>
            <RHFSelect
              name="partner"
              label="Parceiro"
              variant="outlined"
              sx={{
                width: '100%',
                borderRadius: '3px',
              }}
            >
              {productHook.part?.map((option: any, index: number) => (
                <MenuItem key={index + 20} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </RHFSelect>
            <RHFSelect
              disabled={!hook.partner}
              name="redeem"
              label="Resgatável"
              variant="outlined"
              sx={{
                width: '100%',
                borderRadius: '3px',
              }}
            >
              {hook?.redeemsToSet?.map((option: any, index: number) => (
                <MenuItem key={index + 20} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </RHFSelect>
            <Stack
              spacing={2}
              direction="row"
              sx={{
                justifyContent: 'flex-end',
              }}
            >
              <Button
                variant="outlined"
                onClick={() => {
                  productHook.onCloseRedeemModal();
                  hook.reset();
                }}
              >
                Cancelar
              </Button>
              <Button type="submit" variant="contained">
                Associar
              </Button>
            </Stack>
          </Stack>
        </FormProvider>
      </Stack>
    </Dialog>
  );
}
